var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobSelect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9609 13.1406C12.3752 13.1406 12.7109 13.4764 12.7109 13.8906V16.5186C12.7109 16.9328 12.3752 17.2686 11.9609 17.2686C11.5467 17.2686 11.2109 16.9328 11.2109 16.5186V13.8906C11.2109 13.4764 11.5467 13.1406 11.9609 13.1406Z",
    fill: "#5B4200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.21767 11.0465C2.45521 10.7072 2.92285 10.6246 3.26219 10.8622L3.27398 10.8704C5.5624 12.2753 8.60498 13.1406 11.9561 13.1406C15.3051 13.1406 18.3546 12.2764 20.6433 10.8735L20.6493 10.8691C20.9847 10.6262 21.4537 10.7012 21.6966 11.0367C21.9395 11.3722 21.8645 11.8411 21.529 12.084L21.5 12.105C21.4849 12.116 21.4694 12.1264 21.4535 12.1362C18.9008 13.7087 15.5637 14.6406 11.9561 14.6406C8.3482 14.6406 5.02011 13.7085 2.46861 12.1361C2.45617 12.1284 2.44396 12.1204 2.432 12.112L2.402 12.091C2.06266 11.8535 1.98013 11.3858 2.21767 11.0465Z",
    fill: "#5B4200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2638 7.50303C4.07181 8.56458 3.5 10.3345 3.5 13.3514C3.5 16.3683 4.07181 18.1383 5.2638 19.1998C6.48218 20.2849 8.53489 20.8044 11.961 20.8044C15.3877 20.8044 17.4404 20.2848 18.6586 19.1998C19.8505 18.1383 20.422 16.3684 20.422 13.3514C20.422 10.3344 19.8505 8.56453 18.6586 7.50301C17.4404 6.41799 15.3877 5.89844 11.961 5.89844C8.53489 5.89844 6.48218 6.41798 5.2638 7.50303ZM4.26621 6.38285C5.92633 4.9044 8.47912 4.39844 11.961 4.39844C15.4434 4.39844 17.9962 4.90439 19.6562 6.38287C21.3426 7.88485 21.922 10.2164 21.922 13.3514C21.922 16.4864 21.3426 18.818 19.6562 20.32C17.9962 21.7985 15.4434 22.3044 11.961 22.3044C8.47912 22.3044 5.92633 21.7984 4.26621 20.32C2.5797 18.818 2 16.4865 2 13.3514C2 10.2163 2.5797 7.8848 4.26621 6.38285Z",
    fill: "#5B4200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94922 4.74212C7.94922 3.14009 9.13573 1.70312 10.7592 1.70312H13.1642C14.7877 1.70312 15.9742 3.14009 15.9742 4.74212V5.37212C15.9742 5.78633 15.6385 6.12212 15.2242 6.12212C14.81 6.12212 14.4742 5.78633 14.4742 5.37212V4.74212C14.4742 3.81615 13.8147 3.20312 13.1642 3.20312H10.7592C10.1087 3.20312 9.44922 3.81615 9.44922 4.74212V5.37212C9.44922 5.78633 9.11344 6.12212 8.69922 6.12212C8.28501 6.12212 7.94922 5.78633 7.94922 5.37212V4.74212Z",
    fill: "#5B4200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSelect);
export default __webpack_public_path__ + "static/media/JobSelect.0c55e525e3198854c420033a331dcdbf.svg";
export { ForwardRef as ReactComponent };